<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e1927"><span>CONTENTS</span></p>
<p class="cct" id="d7e1977"><span><a href="#/Perr_9781595554048_epub_c8_r1#d7e1" id="d6e1">1. Carver’s George</a></span></p>
<p class="cct" id="d7e2007"><span><a href="#/Perr_9781595554048_epub_c9_r1#d7e2" id="d6e2">2. Wandering Years</a></span></p>
<p class="cct" id="d7e2037"><span><span href="#/Perr_9781595554048_epub_c10_r1#d7e3" id="d6e3" title="Link target outside of Sample">3. The Road to Tuskegee</span></span></p>
<p class="cct" id="d7e2067"><span><span href="#/Perr_9781595554048_epub_c11_r1#d7e4" id="d6e4" title="Link target outside of Sample">4. Pressures and Politics</span></span></p>
<p class="cct" id="d7e2097"><span><span href="#/Perr_9781595554048_epub_c12_r1#d7e5" id="d6e5" title="Link target outside of Sample">5. From Power to Power</span></span></p>
<p class="cct" id="d7e2127"><span><span href="#/Perr_9781595554048_epub_c13_r1#d7e6" id="d6e6" title="Link target outside of Sample">6. Out of the Shadow</span></span></p>
<p class="cct" id="d7e2167"><span><span href="#/Perr_9781595554048_epub_c14_r1#d7e7" id="d6e7" title="Link target outside of Sample">7. Science Shall Make You Free</span></span></p>
<p class="cct" id="d7e2197"><span><span href="#/Perr_9781595554048_epub_c15_r1#d7e8" id="d6e8" title="Link target outside of Sample">8. Simply the Truth</span></span></p>
<p class="cct" id="d7e2227"><span><span href="#/Perr_9781595554048_epub_c16_r1#d7e9" id="d6e9" title="Link target outside of Sample">9. The Peanut Man</span></span></p>
<p class="cct" id="d7e2257"><span><span href="#/Perr_9781595554048_epub_c17_r1#d7e10" id="d6e10" title="Link target outside of Sample">10. In the Midst of Plenty</span></span></p>
<p class="cct" id="d7e2287"><span><span href="#/Perr_9781595554048_epub_c18_r1#d7e11" id="d6e11" title="Link target outside of Sample">11. The Public Figure</span></span></p>
<p class="cct" id="d7e2327"><span><span href="#/Perr_9781595554048_epub_c19_r1#d7e12" id="d6e12" title="Link target outside of Sample">12. The Gift of Hope</span><br/><br/></span></p>
<p class="cct" id="d7e235d7"><span><span href="#/Perr_9781595554048_epub_c20_r1#d7e13" id="d6e13" title="Link target outside of Sample"><i>Epilogue</i></span></span></p>
<p class="cct" id="d7e2357"><span><span href="#/Perr_9781595554048_epub_c21_r1#d7e14" id="d6e14" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
<p class="cct" id="d7e2387"><span><span href="#/Perr_9781595554048_epub_c22_r1#d7e15" id="d6e15" title="Link target outside of Sample"><i>Notes</i></span></span></p>
<p class="cct" id="d9t0017"><span><span href="#/Perr_9781595554048_epub_c23_r1#d7e16" id="d6e16" title="Link target outside of Sample"><i>Bibliography</i></span></span></p>
<p class="cct" id="d7e2417"><span><span href="#/Perr_9781595554048_epub_c24_r1#d7e17" id="d6e17" title="Link target outside of Sample"><i>About the Author</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Perr_9781595554048_epub_c7_r1.vue?dea1dc4a